import { tuple } from '../_utils/props-tools';
import PropTypes from '../_utils/props-types';
export const modalProps = () => ({
    prefixCls: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).def(520),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    mask: PropTypes.bool.def(true),
    maskStyle: PropTypes.object,
    maskClosable: PropTypes.bool.def(true),
    closable: PropTypes.bool.def(true),
    visible: PropTypes.bool.def(false),
    container: PropTypes.oneOfType([PropTypes.func, PropTypes.string, HTMLElement]),
    forceRender: PropTypes.bool,
    wrapClass: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    title: PropTypes.any,
    footer: PropTypes.any,
    footerBtnPosition: PropTypes.oneOf(tuple('center', 'left', 'right')).def('right'),
    closeIcon: PropTypes.any,
    okText: PropTypes.any,
    ok: { type: Function },
    cancel: { type: Function },
    cancelText: PropTypes.any,
    zIndex: PropTypes.number,
    animation: PropTypes.string.def('scale'),
    placement: PropTypes.oneOf(tuple('left', 'top', 'right', 'bottom', 'center')).def('center'),
    afterClose: PropTypes.func.def(() => { })
});
